/* eslint-disable max-classes-per-file */

import CartService, { CART_EVENTS } from './cart-service';
import ShopifyService from './ajax-service';

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', async (event) => {
      event.preventDefault();
      const cartItems =
        this.closest('cart-items') || this.closest('cart-drawer-items');
      if (this.dataset.gwp === 'true' || this.dataset.gwp === true) {
        await ShopifyService.remove(cartItems.cart, [this.dataset.key]);
        const cartItem = this.closest('.cart-item');
        cartItem.remove();
      } else if (this.dataset.bundle) {
        const items = [
          ...cartItems.querySelectorAll(
            `[data-bundle="${this.dataset.bundle}"]`,
          ),
        ].map((el) => el.dataset.key);
        cartItems.removeLineItem(items);
      } else {
        cartItems.removeLineItem(this.dataset.key);
      }
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);
class CartItems extends HTMLElement {
  constructor() {
    super();
    this.cartService = new CartService();
    this.trapFocus = null;
    this.listener = undefined;

    this.addEventListener('change', this.onChange);
  }

  connectedCallback() {
    this.cart = this.cartService.cart;

    if (this.tagName === 'CART-DRAWER-ITEMS') {
      this.cartDrawer = this.closest('cart-drawer');
    }

    this.listener = (event) => {
      switch (event) {
        case CART_EVENTS.UPDATE:
          this.onCartUpdate();
          break;
        case CART_EVENTS.OPEN:
          this.cartDrawer?.open();
          break;
        case CART_EVENTS.LOADING:
          this.closest('cart-drawer').classList.add('cart-loading');
          break;
        case CART_EVENTS.FINISHED:
          this.closest('cart-drawer').classList.remove('cart-loading');
          break;
        default:
          break;
      }
    };
    this.cartService.addListener(this.listener);
  }

  disconnectedCallback() {
    if (this.listener) {
      this.cartService.removeListener(this.listener);
    }
  }

  onChange(event) {
    if (event.target.tagName === 'INPUT') {
      const qty = parseInt(event.target.value, 10);
      const item = event.target.closest('.cart-item');
      const { key } = item.dataset;
      const payload = [
        {
          id: key,
          quantity: qty,
        },
      ];

      this.cartService.update(payload);
    }
  }

  addToCart(payload) {
    this.cartService.add(payload);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      this.cartDrawer = this.cartDrawer || this.closest('cart-drawer');
      this.cartIncentives =
        this.cartIncentives || this.cartDrawer.querySelector('cart-incentives');
      fetch(`${window.TMW.routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            'text/html',
          );
          const selectors = [
            '[data-cart-drawer-header]',
            'cart-drawer-items',
            '[data-cart-upsell]',
            '[data-cart-drawer-footer]',
            '[data-cart-empty]',
          ];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          this.cartDrawer.renderContents(
            html.querySelector('[data-cart-data]'),
          );
          this.cartIncentives?.renderProgress(
            html.querySelector('[data-cart-data]'),
          );
        });
    } else {
      fetch(`${window.TMW.routes.cart_url}?section_id=main-cart`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            'text/html',
          );
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        });
    }
  }

  removeLineItem(payload) {
    const payloadArray = Array.isArray(payload) ? payload : [payload];
    this.cartService.remove(payloadArray);
  }
}

if (!customElements.get('cart-items')) {
  customElements.define('cart-items', CartItems);
}

class CartDrawerItems extends CartItems {}

if (!customElements.get('cart-drawer-items')) {
  customElements.define('cart-drawer-items', CartDrawerItems);
}
